import { render, staticRenderFns } from "./budgetInfo.vue?vue&type=template&id=0b7fcc10&scoped=true&"
import script from "./budgetInfo.vue?vue&type=script&lang=js&"
export * from "./budgetInfo.vue?vue&type=script&lang=js&"
import style0 from "./budgetInfo.vue?vue&type=style&index=0&id=0b7fcc10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7fcc10",
  null
  
)

export default component.exports